import {
  Accordion,
  Bubble,
  Icon,
  Markdown,
} from '@frontendmentorio/design-system-v2';

function Heading({ isOpen, ...props }) {
  return (
    <h2
      className="cursor-pointer flex justify-between font-secondary items-center p-4 text-violet-600 text-xl"
      {...props}
    >
      AI Analysis Summary
      <Icon
        className="text-neutral-500 text-sm"
        name={isOpen ? 'chevron-down' : 'chevron-right'}
        style="solid"
      />
    </h2>
  );
}

function ListItem({ children, position }) {
  return (
    <li className="flex gap-2 items-start">
      <Bubble className="bg-violet-600 flex items-center justify-center shrink-0 text-sm w-[1.8rem]">
        {position}
      </Bubble>
      <Markdown>{children}</Markdown>
    </li>
  );
}

export default function Summary({ isOpen, report }) {
  if (!report?.summary) return null;

  return (
    <Accordion
      className="bg-violet-50 border-violet-200"
      heading={<Heading isOpen={isOpen} />}
      isOpen={isOpen}
    >
      <div className="flex flex-col gap-3 p-4">
        <Markdown>{report.summary}</Markdown>

        {report.recommendations.length > 0 && (
          <>
            <h3 className="font-secondary text-lg">
              Priority recommendations:
            </h3>

            <ol className="flex flex-col gap-2">
              {report.recommendations.map((recommendation, index) => (
                <ListItem key={index} position={index + 1}>
                  {recommendation}
                </ListItem>
              ))}
            </ol>
          </>
        )}
      </div>
    </Accordion>
  );
}
